//
// MapElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GraphElementController";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "@sas-dvr/ltjs-commons/maps/MapSearchHint";
import "@sas-dvr/ltjs-commons/maps/GeoEnrichmentResult";
import "@sas-dvr/ltjs-gtl/models/layoutOverlayMap/map/MapPin";
import "@sas-dvr/ltjs-gtl/models/core/controller/MapChartOperations";

var MapElementController = createModule("BIRD::MapElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController","BIRD::GraphElementController"], EventDispatcher, [
    {
        ESRI_PORTAL_TOKEN_ACQUIRED: 50027,
        CURRENT_SEARCH_MARKER_SELECTED: 50023,
        REVERSE_GEOCODE_RESULT_READY: 50030,
        GEO_ENRICHMENT_READY: 50026,
        MAP_FEATURES_REQUESTED: 50028,
        SEARCH_RESULTS_READY: 50021,
        SEARCH_HINTS_READY: 50022,
        PINS_UPDATED: 50031,
        DRIVE_TIME_RESULTS_READY: 50025,
        MAP_BOUNDS_CHANGED: 50024,
        MISSING_MAP_DATA: 50011,
        MAP_FEATURES_RECEIVED: 50029,
    },
    ,
    ,
    ,
    {
        getMapChartOperations: [1],
        requestSearchHints: [0,7],
        zoomOut: [0],
        getSearchTerm: [7],
        doDriveTime: [0,11,2,5,4],
        enrichSelectionPolygon: [0,[7]],
        canZoomIn: [2],
        search: [0,7,7],
        cancelDriveTime: [0],
        searchAtPoint: [0,7,4,4],
        doMultiDriveTimeWithTraffic: [0,11,2,[5],4,4,4,4,4],
        canEnrichSelectionPolygon: [2,11],
        getViewSize: [13,4],
        getGeoEnrichmentResultModels: [[1]],
        setCurrentSearchMarkerIndex: [0,3,2],
        getCurrentSearchMarkerIndex: [3],
        getCurrentSearchMarkerLocation: [11],
        getSearchHints: [[1]],
        zoomIn: [0],
        doDriveTimeWithTraffic: [0,11,2,5,4,4,4,4,4],
        canDoSearch: [2],
        getMaximumBufferDistance: [5,4,4],
        clearSearch: [0],
        getGeoEnrichmentResults: [7],
        getCurrentPinIndex: [3],
        canZoomOut: [2],
        cancelSearch: [0],
        doMultiDriveTime: [0,11,2,[5],4],
        resetView: [0],
        doRadial: [0,11,2,5,4],
        getSearchResults: [[1]],
        setCurrentPinIndex: [1,3,2],
        hasOperations: [2],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default MapElementController;
